import { ModalActionTypes } from '@acorns/web-components'

import AlertBadge from 'assets/icons/alert-badge.png'
import WarningIcon from 'assets/icons/exclamation-mark-gray-circle.svg'

import { DYNAMIC_COPY } from './errorCopy'

export const getGeneralError = (error, props, retryHandler, errorCode?: number) => {
  const errorStatus =
    errorCode ??
    (error.graphQLErrors?.length
      ? error.graphQLErrors?.[0]?.extensions?.response?.status
      : error?.networkError?.statusCode)
  const isNetworkError = !window.navigator.onLine
  const isTimeoutError = error.graphQLErrors?.[0]?.extensions?.response?.timeout

  const genericErrorModal = {
    message: 'It looks like something went wrong.',
    title: 'Oops!',
    image: AlertBadge,
    actions: [
      {
        handler: props.closeErrorModal,
        type: ModalActionTypes.primary,
        label: 'Ok',
      },
    ],
  }

  if (errorStatus || isNetworkError || isTimeoutError) {
    const { message, title, secondaryCta, primaryCta } = DYNAMIC_COPY[errorStatus ?? 'networkError']

    const defaults = {
      message,
      title,
      image: WarningIcon,
    }

    const closeAndRetryActions = [
      {
        handler: props.closeErrorModal,
        type: ModalActionTypes.secondary,
        label: secondaryCta,
      },
      {
        handler: retryHandler,
        type: ModalActionTypes.primary,
        label: primaryCta,
      },
    ]

    const closeAction = [
      {
        handler: props.closeErrorModal,
        type: ModalActionTypes.primary,
        label: primaryCta,
      },
    ]

    if (isNetworkError || isTimeoutError) {
      return {
        ...defaults,
        actions: closeAndRetryActions,
      }
    }

    switch (errorStatus) {
      case 500:
        return {
          ...defaults,
          actions: closeAndRetryActions,
        }
      case 408:
      case 504:
        return {
          ...defaults,
          actions: closeAndRetryActions,
        }
      case 429:
        return {
          ...defaults,
          actions: closeAction,
        }
      case 400:
        return {
          ...defaults,
          actions: closeAction,
        }
      default:
        return genericErrorModal
    }
  } else {
    return genericErrorModal
  }
}
